import { ITheme } from "@fluentui/react";


export const getStyles = (theme: ITheme, hasMessage = false) => {
    return {
        container: {
            flex: 1,
            display: "flex",
            flexDirection: "column" as const,
            height: "100%",
            overflow: "auto" as const,
            backgroundColor: hasMessage ? "#F7F9F9" : "#EAEFEF",
            maxWidth: "100%"
        },
    separator: {
        width: 0,
        height: 35,
        border: `1.5px solid ${theme.palette.themePrimary}`
    },
    appName: {
        fontSize: "44px",
        fontWeight: 700,
        color: theme.palette.themePrimary,
        lineHeight:"36px",
        margin: 0
    },
    welcomeMessage: {
        fontSize: theme.fonts.xLargePlus.fontSize,
        lineHeight: theme.fonts.xLarge.lineHeight,
        fontWeight: 500,
        textAlign: 'center' as const,
        color: theme.palette.neutralSecondaryAlt
    },
    chatContainer: {
        height: "100%",
        justifyContent: "space-between"
    },
    welcomeState: {
        flex: 1,
        display: "flex",
        flexDirection: "column" as const,
        justifyContent: "center" as const,
        alignItems: "center" as const,
        gap: 32,
        width: "100%",
        maxWidth: "900px",
        margin: "0 auto",
        padding: "0 20px",
    },
    welcomeContainer: {
        display: "flex",
        flexDirection: "column" as const,
        gap: 20,
        padding: 20,
        alignItems: "center" as const,
    },
    appInfoContainer: {
        display: "flex",
        gap: 13,
        alignItems: "flex-end" as const,
        direction: "ltr" as const,
    },
    appLogo: {
        height: 48,
        width: 135,
    },
    chatActive: {
        flex: 1,
        display: "flex",
        flexDirection: "column" as const,
        overflow: "hidden" as const,
        width: "100%",
        padding: "0 0 16px",
    },
    chatMessageStream: {
        flex: 1,
        overflowY: "auto" as const,
        display: "flex",
        flexDirection: "column" as const,
        padding: "10px max(20px, calc((100% - 760px) / 2)) 8px",
    },
    chatMessageGptt: {
        marginBottom: 12,
        display: "flex",
        flexDirection: "column" as const,
    },
    chatInputWrapper: {
        width: "100%",
        padding: "0 max(20px, calc((100% - 760px) / 2))",
    },
    spinnerWrapper1: {},
    }
}